// login-sso.component.ts
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { Store } from '@ngrx/store';
import { userActions } from '../../store/user.actions';
import { ToastService } from '../../../shared/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { isAuthenticatedSelector } from '../../store/user.selectors';

@Component({
    template: `<p>Loading...</p>`,
    providers: [
        ToastService,
        TranslateService
    ],
    standalone: false
})
export class LoginSsoComponent implements OnInit {
  private store = inject(Store);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);
  isAuthenticated$: Observable<boolean> = this.store.select(isAuthenticatedSelector);

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
  ) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.store.dispatch(userActions.loginWithSso({ token }));
    } else {
        this.toastService.error(this.translateService.instant("login.invalidData"), '');
    }
    this.isAuthenticated$.subscribe(x => {
      if (x) {
            this.router.navigate(['dashboard']);
        }
    });
  }
}

